import { RailExtras, type IRailAction } from "feat/nativeNavigation/rail-actions";
import { useActivityFeed } from "feat/activity-feed/hooks";
import { useGuestStore } from "feat/guest/guest.store";
import { useGlobalRouter } from "feat/globalRouter/useGlobalRouter";
import { routes } from "routing";
import { useShowExpensesButton } from "./CarouselOverlay";
import { toggleZoneMode } from "./slide/newComps/CarouselZoneToggle";

/**
 * The itinerary header's itinerary menu, expenses, alerts and time mode on the vertical bar (iPhone
 * Duo held wide), top to bottom after Home's main action, as `RailHeaderControls` puts them on the
 * web's tab rail.
 */
export function VerticalBarHeaderControls() {
  const isGuest = useGuestStore((s) => s.isGuestMode);
  const showExpenses = useShowExpensesButton();
  const hasFeed = useActivityFeed().length > 0;
  const { pushPath } = useGlobalRouter();

  const actions: IRailAction[] = [
    ...(!isGuest
      ? [
          {
            id: "rail-see-all-itineraries",
            icon: "Hamburger" as const,
            disabled: false,
            // Tagged as reached from Home, as `CarouselSeeAllItineraries` does.
            onClick: () => pushPath(routes.itineraries.path, { animation: "none", state: { fromTab: "home" } }),
          },
        ]
      : []),
    ...(showExpenses
      ? [
          {
            id: "rail-expenses",
            icon: "Billing" as const,
            disabled: false,
            onClick: () => pushPath(routes.edit.expenses.path),
          },
        ]
      : []),
    ...(!isGuest
      ? [
          {
            id: "rail-activity-feed",
            icon: hasFeed ? ("NotificationUnread" as const) : ("Notification" as const),
            disabled: false,
            onClick: () => pushPath(routes.activityFeed.path),
          },
        ]
      : []),
    { id: "rail-timezone-toggle", icon: "Time", disabled: false, onClick: toggleZoneMode },
  ];

  return <RailExtras tab="home" actions={actions} />;
}
